"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M9.953 8.273a4.081 4.081 0 000 5.766l1.334-1.336a2.192 2.192 0 010-3.095l3.09-3.09c.414-.414.963-.641 1.548-.641.585 0 1.135.227 1.548.64a2.192 2.192 0 010 3.096l-1.112 1.112 1.335 1.335 1.112-1.112a4.081 4.081 0 000-5.765 4.052 4.052 0 00-2.883-1.194 4.051 4.051 0 00-2.882 1.194l-3.09 3.09z" }),
    React.createElement("path", { d: "M5.192 18.737a4.064 4.064 0 002.883 1.192 4.064 4.064 0 002.883-1.192l3.09-3.09a4.081 4.081 0 000-5.765l-1.335 1.335a2.192 2.192 0 010 3.095l-3.09 3.09a2.192 2.192 0 01-3.096 0 2.174 2.174 0 01-.64-1.547c0-.585.227-1.135.64-1.548l1.112-1.112-1.335-1.335-1.112 1.112a4.081 4.081 0 000 5.765z" })), "Link");
//# sourceMappingURL=Link.js.map